"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _InfoPanel = _interopRequireDefault(require("../InfoPanel/InfoPanel"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// eslint-disable-next-line max-len
var NOTE_DISCLOSURE_MESSAGE = 'Include only the minimum information necessary to provide the requested services. Do not include sensitive information (e.g., interpersonal violence, substance use, or legal services information).';
var NoteDisclosure = function NoteDisclosure(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_InfoPanel["default"], {
    className: className,
    message: NOTE_DISCLOSURE_MESSAGE
  });
};
NoteDisclosure.propTypes = {
  /* Class name */
  className: _propTypes["default"].string
};
NoteDisclosure.defaultProps = {
  className: ''
};
var _default = exports["default"] = NoteDisclosure;